import styled from 'styled-components';
import { mediaQuery } from '../../common/styles/styleUtil';

export const CardAdWrapper = styled.div`
  height: 358px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f7f8f9;

  @media (${mediaQuery.tablet}) {
    background: transparent;
    height: 282px;
  }
`;
